/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import './CategorySelect.styles.scss';

import TripleStateSelectionIcon from '../../../components/icons/TripleStateSelectionIcon';

interface Props {
  selectedTotal: number;
  allTotal: number;
  color: string;
  showTotals: boolean;
  zeroSelected?: boolean;
  onClick?(): void;
}

const CategorySelect = ({ selectedTotal, zeroSelected, allTotal, color, showTotals, onClick }: Props) => {
  let viewStateName = '';
  let fontColor = null;

  if (selectedTotal === 0 && !zeroSelected) {
    viewStateName = 'empty';
  } else if (selectedTotal === allTotal) {
    viewStateName = 'checked';
    fontColor = color;
  } else {
    viewStateName = 'partial';
    fontColor = color;
  }

  return (
    <span className="cmp-categoryselect">
      {
        showTotals ? (
          <span className="cmp-categoryselect-total" style={{ color: fontColor }}>
            {selectedTotal}/{allTotal}
          </span>
        ) : null
      }
      <span className="cmp-categoryselect-icon" onClick={onClick}>
        <TripleStateSelectionIcon viewState={viewStateName} color={color} />
      </span>
    </span>
  );
};

export default CategorySelect;
